'use client'
import {ReactNode} from "react";
import {useHttpContext} from "@web-libs/core/http/infrastructure/client-side/http.context";
import {createOwnUserConcern, OwnUserContext} from "@web-libs/features/users/application/use-own-user.concern";
import {useInitOnce} from "@web-libs/util/hooks/use-init-once";
import {OwnUserDTO} from "@web-libs/features/users/api/user-dto.types";

export const OwnUserProvider = ({ children }: { children: ReactNode }) => {
    const http = useHttpContext()
    const ownUserConcern = useInitOnce(() => createOwnUserConcern(
        () => http.get<OwnUserDTO>("/users/self"),
    ))

    return (
        <OwnUserContext.Provider value={ownUserConcern}>
            {children}
        </OwnUserContext.Provider>
    )
}
